import React from 'react'
import { AppContainer, AppLogo } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
import { Animation, Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import './AppHeader.css'

const AppHeader = props => {
  const theme = props.app.location && props.app.location.label === 'question'
    ? { color: '#141251' } : {}


  return (
    <div className="App-header" style={theme}>
      <Animation name="slideInDown">
        <AppContainer>
          <div className="App-header-top">
            <div className="App-header-left">
              <AppLogo />
            </div>
            <div className="App-header-right">
              <div className="App-navigation">
                <a onClick={props.app.toggleNavigation}><Icon name="menu" size="large" /></a>
              </div>
            </div>
          </div>
        </AppContainer>
      </Animation>
    </div>
  )
}

export default withApp(AppHeader)
